import styled from 'styled-components';

import {media} from '../../styles/components/media-queries';
import {Button2} from '../../styles/components/button.style';
import {TextInput} from '../../containers/CheckoutPage/CheckoutPage.style';
import {fontSize} from '../../styles/core/fontSize.style';

export const Title = styled.h3`
  font-size: ${fontSize.size24};
  margin: 0;
`;

export const SubmitButton = Button2.extend`
  width: auto;
`;

export const CancelButton = Button2.extend`
  width: auto;
  margin-left: ${props => props.theme.checkoutPage.modalButtonMargin};
  background-color: ${props => props.theme.disabledButtonBackground};
  border-bottom: ${props => props.theme.button.secondary.borderBottom};
  &:hover {
    background-color: ${props => props.theme.disabledButtonHoverBackground};
  }
  ${media.small`
    margin-left: 0;
    margin-top: ${props => props.theme.checkoutPage.modalButtonMargin};
  `};
`;

export const TextInputStyled = TextInput.extend`
  margin: ${props => props.theme.checkoutPage.modalButtonMargin} 0;
`;



// WEBPACK FOOTER //
// ./components/VoucherModal/VoucherModal.style.js